import React from 'react';
import { faBullhorn } from '@fortawesome/pro-regular-svg-icons';
import { PulseButton } from 'src/components';

interface ReportDataIssueButtonProps {
  onClick: () => void;
}

const ReportDataIssueButton = ({ onClick }: ReportDataIssueButtonProps) => {
  return (
    <div className="w-full flex justify-center">
      <PulseButton
        size="sm"
        variant="plain"
        color="neutral"
        onClick={onClick}
        startDecorator={faBullhorn}
        className="rounded-full"
      >
        Report Data Issue
      </PulseButton>
    </div>
  );
};

export default ReportDataIssueButton;
